import { render, staticRenderFns } from "./shortChat.vue?vue&type=template&id=1bcf2e08&scoped=true&"
import script from "./shortChat.vue?vue&type=script&lang=js&"
export * from "./shortChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf2e08",
  null
  
)

export default component.exports